var React = require('react');

function CheckmarkCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.16 5.9l-4.164 5.418a1 1 0 0 1-.74.39c-.018.002-.035.002-.053.002-.273 0-.535-.113-.725-.312L3.91 8.694a1 1 0 0 1 1.45-1.378l1.763 1.856 3.451-4.492A1 1 0 0 1 12.16 5.9M8 1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7"}));
}

CheckmarkCircle.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = CheckmarkCircle;

CheckmarkCircle.default = CheckmarkCircle;
